import { useEffect, useCallback, useRef } from 'react';

import { API_URLS, APPLICATION_HEADERS } from '../../../components/common/headers';
import { useSyncRef } from '../../../hooks/useSyncRef';
import { isEqualDeep } from '../../../utils/objects/isEqualDeep';
import { protectApiViaOkta } from '../../../utils/protectApiViaOkta';

export const useFetchLocationsCount = ({
  isEditDeleteSuccessCB,
  preSearchRequestObjectRef,
  preSearchRequestTransactionsObjectRef,
  searchRequestObject,
  setIsEmptyResponse,
  setPage,
  setResponseData,
  setTotalCount,
  totalCount,
  sortField,
  sortDirection,
  pageSize,
}) => {
  const totalCountRef = useSyncRef(totalCount || 0);

  const fetchLocationsCount = useCallback(
    async (reqObj, isEditDeleteSuccessCB, customPageSize) => {
      if (isEqualDeep(reqObj, preSearchRequestObjectRef.current) && !isEditDeleteSuccessCB) {
        return;
      }

      const actualPageSize = customPageSize ?? pageSize;

      const countReqObj = {
        ...reqObj,
        pageSize: actualPageSize,
        ...(sortField && {
          sortField:
            sortField === 'provider_updated_date'
              ? 'updated_date'
              : sortField === 'formatted_address'
              ? 'address'
              : sortField === 'provider_name'
              ? 'provider_name'
              : sortField,
        }),
        ...(sortField && { sortDirection: sortDirection }),
      };

      const URL = `${API_URLS.searchLocationsCountURL}`;

      try {
        const response = await protectApiViaOkta('post', URL, countReqObj);

        if (response?.status === 200 && response?.data && response?.data?.count) {
          setIsEmptyResponse(false);
          const { count } = response.data;

          setTotalCount(count);
          setPage(1);

          preSearchRequestObjectRef.current = reqObj;
        } else {
          console.error('Error: Count is not found in the response');
          preSearchRequestTransactionsObjectRef.current = '';
          if (totalCountRef.current === 0 || response?.data?.count === 0) {
            setIsEmptyResponse(true);
          }
        }
      } catch (error) {
        console.error('useFetchLocationsCount: Error fetching count data:', error);
      }
    },
    [
      setResponseData,
      setTotalCount,
      setPage,
      setIsEmptyResponse,
      preSearchRequestObjectRef,
      preSearchRequestTransactionsObjectRef,
      totalCountRef,
    ],
  );

  useEffect(() => {
    if (isEditDeleteSuccessCB) {
      fetchLocationsCount(searchRequestObject, isEditDeleteSuccessCB);
    }
  }, [fetchLocationsCount, isEditDeleteSuccessCB, searchRequestObject]);

  return { fetchLocationsCount };
};
